module.exports = __webpack_public_path__ + "6d2be16447675a1fffa132e2bb7f9bb5.png";